import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="header">
      <RouterLink to="/" className="header__logo">
        Krysalis Business
      </RouterLink>
      <nav className="header__nav">
        <RouterLink to="/artifact-types" className="header__link">
          Artifact Types
        </RouterLink>
        <RouterLink to="/admin/global-properties" className="header__link">
          Global Properties
        </RouterLink>
        <RouterLink to="/prime/artifacts" className="header__link">
          Prime Artifacts
        </RouterLink>
        <RouterLink to="/processes" className="header__link">
          Process Relationships
        </RouterLink>
        <RouterLink to="/gpt-integration" className="header__link">
          GPT Assistant
        </RouterLink>
        <RouterLink to="/architecture-agent" className="header__link">
          Architecture Agent
        </RouterLink>
        <RouterLink to="/development" className="header__link">
          Development
        </RouterLink>
        <RouterLink to="/user-management" className="header__link">
          User Management
        </RouterLink>
      </nav>
    </header>
  );
};

export default Header;
